import './cookie-notification.style.sass';
import template from './cookie-notification.tpl.pug';

class CookieNotificationController {
    /* @ngInject */
    constructor($timeout, storageService) {
        this.$timeout = $timeout;
        this.storageService = storageService;
    }

    $onInit() {
        this.exists = true;
    }

    $postLink() {
        this.$timeout(() => {
            this.visible = !this.storageService.getItem('cp');
            this.exists = this.visible;
        }, 0);
    }

    acknowledge() {
        this.storageService.setItem('cp', Date.now());
        this.visible = false;
    }
}

export default {
    selector: 'dbACookieNotification',
    template: template(),
    controller: CookieNotificationController
};



// WEBPACK FOOTER //
// ./src/application/component/cookie-notification/cookie-notification.cmpt.js